<template>
  <input
    :key="dateKey"
    type="date"
    ref="input"
    v-bind:value="dateToYYYYMMDD(value)"
    v-on:input="updateValue($event.target)"
    v-on:focus="selectAll"
  />
</template>

<style lang="scss" scoped>
</style>

<script>
export default {
  props: {
    value: {
      type: String | Date,
      default: ""
    }
  },
  data(){
    return{
      dateKey:0
    }
  },
  methods: {
    dateToYYYYMMDD(date) {
      // may have timezone caveats https://stackoverflow.com/a/29774197/1850609
      if (date != "Invalid Date") {
        try {
          date = date.toISOString();
        } catch (error) {}

        return date && date.split("T")[0];
      }
    },
    updateValue: function(target) {
      this.$emit("input", target.valueAsDate);
    },
    selectAll: function(event) {
      // Workaround for Safari bug
      // https://stackoverflow.com/q/1269722/1850609
      setTimeout(function() {
        event.target.select();
      }, 0);
    }
  },
  created() {
    this.value = this.value.split(" ")[0];
    this.value = new Date(this.value);
    this.dateKey+=1;
  }
};
</script>
